import { updateRecord } from "../updateRecord";
import { updateFolder } from "../updateFolder";
import { InstanceType } from "./types";

export const updateInstance = {
  [InstanceType.RECORD]: updateRecord,
  [InstanceType.FOLDER]: updateFolder,
};
